import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense } from 'react';
import useResponsive from '../../../shared/hooks/useResponsive';
import Loader from '../../Atoms/Loader/Loader';
const Pagination = (props) => {
    const { isTablet, isMobile } = useResponsive();
    let PaginationComponent;
    if (isMobile || isTablet) {
        PaginationComponent = lazy(() => import('./PaginationMobile/PaginationMobile'));
    }
    else {
        PaginationComponent = lazy(() => import('./PaginationDesktop/PaginationDesktop'));
    }
    return (_jsx(Suspense, Object.assign({ fallback: _jsx(Loader, {}, void 0) }, { children: _jsx(PaginationComponent, Object.assign({}, props), void 0) }), void 0));
};
export default Pagination;
//# sourceMappingURL=Pagination.js.map